import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import dataModel from '../../models/DataModel';

import './APIKeyWidget.scss';
import Input from '../Input';

/**
 * APIKeyWidget is used by a super user to display the current company API key,
 *  or generate a new one. The only two states are apiKey=null and apiKey={string}.
 */
export class APIKeyWidget extends React.Component {

  constructor(props) {

    APIKeyWidget.propTypes = {
      // The api key for the company, if it has already been generated
      apiKey: PropTypes.string,
    };
    super(props);

    this.state = {
      apiKey: null,
    };
   
    this.generateNewKey = this.generateNewKey.bind(this);
    this.handleRegenerateClick = this.handleRegenerateClick.bind(this);
  }

  componentDidMount() {
    this.setState({ apiKey: this.props.apiKey });
  }

  handleRegenerateClick() {
    this.props.dataModel.showGlobalModal('SYSTEM_POPUP', {
      
      message: 'Are you sure you want to regenerate the API Key? The current key will be overwritten.',
      cancelButtonText: 'CANCEL',
      okButtonText: 'YES',
      height: 184,
      width: 320,
      handleOwnerOk: this.generateNewKey,
    });
  }

  generateNewKey() {
    dataModel.companiesDAO.generateAPIKeyForCurrentCompany()
      .then((companyWithNewApiKey) => {
        this.setState({ apiKey: companyWithNewApiKey.api_key });
      });
  } 

  render() {
    let generateButton = <button onClick={this.generateNewKey} className='api-key-widget__button api-key-widget__button--generate'>GENERATE</button>;
    
    if(this.state.apiKey) {
      // key already generated
      generateButton = <button onClick={this.handleRegenerateClick} className='api-key-widget__button api-key-widget__button--regenerate'>REGENERATE</button>;
    }

    return (
      <div className="api-key-widget">
        <div className='api-key-widget__label'>API KEY</div>
        <Input readOnly className='api-key-widget__input' value={this.state.apiKey || 'API Key has not been generated'}/>
        {generateButton}
      </div>
    );
  }
}

export default connect( 
  (state) => ({
    dataModel: dataModel,
  })
)(APIKeyWidget);



// WEBPACK FOOTER //
// ./src/components/APIKeyWidget/index.js